// Dados cadastrais da ByFluent, conforme o comprovante de inscrição no CNPJ emitido em 13/10/2026.
// São públicos (rodapé, documentos legais e e-mails) e não variam por ambiente.
export const COMPANY = {
  brand: "ByFluent",
  tradeName: "ByFluent Idiomas",
  legalName: "Pereira e Leão Ensino de Idiomas Ltda",
  cnpj: "69.584.768/0001-56",
  legalNature: "sociedade empresária limitada",
  address: {
    street: "Rua Visconde do Rio Branco",
    number: "1488",
    complement: "conjunto 909, 9º andar, Condomínio Universe Life Square, Bloco Comercial",
    district: "Centro",
    city: "Curitiba",
    state: "PR",
    postalCode: "80420-210",
  },
  contactEmail: "contato@byfluent.com.br",
  privacyEmail: "privacidade@byfluent.com.br",
  website: "https://byfluent.com.br",
} as const;

/** Endereço em uma linha: rua, número, complemento, bairro, cidade/UF e CEP. */
export function companyAddress(short = false): string {
  const a = COMPANY.address;
  const complement = short ? "conj. 909" : a.complement;
  return `${a.street}, ${a.number}, ${complement}, ${a.district}, ${a.city}/${a.state}, CEP ${a.postalCode}`;
}

/** Qualificação usada nos contratos e documentos legais. */
export function companyQualification(): string {
  return `${COMPANY.legalName}, ${COMPANY.legalNature}, inscrita no CNPJ sob o nº ${COMPANY.cnpj}, com sede na ${companyAddress()}`;
}
